
import { create } from "zustand";
import axios from "axios";
import { API_BASE_URL1, API_BASE_URL3 } from "../../../Services/baseApiUrl";
import { apiCall } from "../../../../utils/apiCall";
import { toast } from "react-toastify";

const RouteMastersStore = create((set, get) => ({

    routeMasterData: [],
    loading: false,
    error: false,

    fetchRouteMasters: async (routeCode) => {
        set({ loading: true, error: null });
        try {
            const url = `${API_BASE_URL1}MasterDetails/GetRouteDetails${routeCode ? `?routeCode=${routeCode}` : ""}`;

            const routeData = await apiCall({
                url,
                method: "get",
                token: localStorage.getItem("token"),
            });
            set({
                routeMasterData: Array.isArray(routeData) ? routeData : [],
                loading: false
            });

        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching data");
            if (error.response && error.response.status === 404) {
                set({
                    routeMasterData: [], // fixed typo: routeMasterData → routeMasterData
                    error: "No route masters found.",
                    loading: false
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        }
    },



    addRouteMasterData: async (newRouteMasterData) => {
        set({ loading: true, error: null });
        try {
            const response = await axios.post(
                `${API_BASE_URL1}MasterCreate/AddNewRoute`,
                newRouteMasterData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            set((state) => ({
                routeMasterData: [...state.routeMasterData, response],
                loading: false
            }));
            toast.success(response.data);
            return { success: true };

        } catch (error) {
            console.error("Error adding observation:", error, error.response?.data || error.message);

            // Handle 400 - Validation errors
            if (error.response?.status === 400) {
                const validationErrors = error.response.data.errors || error.response.data;

                if (typeof validationErrors === "object") {
                    let errorMessages = [];

                    Object.keys(validationErrors).forEach((key) => {
                        if (Array.isArray(validationErrors[key])) {
                            validationErrors[key].forEach((msg) => {
                                errorMessages.push(msg);
                            });
                        } else {
                            errorMessages.push(validationErrors[key]);
                        }
                    });

                    errorMessages.forEach((msg) => toast.error(msg));
                    return { success: false, errors: validationErrors };
                }
            }

            // ✅ Handle 409 - Conflict (e.g., duplicate route name)
            if (error.response?.status === 409) {
                const message = error.response.data?.message || "Conflict occurred.";
                toast.error(message);
                return { success: false, errors: { conflict: message } };
            }

            // General error handling
            const errorMessage = error.response?.data?.message || "Failed to add Route Master";
            toast.error(errorMessage);
            set({ error: errorMessage, loading: false });

            return { success: false, errors: { general: errorMessage } };
        }

        finally {
            set({ loading: false });
        }
    },

    updateRouteMasterData: async (existingrouteMasterData) => {
        set({ loading: true, error: null });
        try {
            const response = await axios.put(
                `${API_BASE_URL1}MasterCreate/UpdateNewRoute`,
                existingrouteMasterData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            set((state) => ({
                routeMasterData: [...state.routeMasterData, response],
                loading: false
            }));

            toast.success(response.data);
            return { success: true };

        } catch (error) {
            console.error("Error adding Route Master:", error.response?.data || error.message);

            if (error.response?.status === 400) { // Handle validation errors
                const validationErrors = error.response.data.errors || error.response.data;

                if (typeof validationErrors === "object") {
                    let errorMessages = [];

                    Object.keys(validationErrors).forEach((key) => {
                        if (Array.isArray(validationErrors[key])) {
                            validationErrors[key].forEach((msg) => {
                                errorMessages.push(msg);
                            });
                        } else {
                            errorMessages.push(validationErrors[key]);
                        }
                    });

                    errorMessages.forEach((msg) => toast.error(msg));
                    return { success: false, errors: validationErrors };
                }
            }

            // Handle general errors
            const errorMessage = error.response?.data || "Failed to add Route Master";
            toast.error(errorMessage);
            set({ error: errorMessage, loading: false });

            return { success: false, errors: { general: errorMessage } };
        }
        finally {
            set({ loading: false });
        }
    },


}))

export default RouteMastersStore